import {useUDData} from '@udemy/ud-data';

import {useGetPauseSubscriptionBannerQuery} from 'src/generated/graphql';

import {type PauseSubscriptionEnrollment} from './pause-subscription-banner';

/**
 * Loads the current subscription enrollment for the pause banner.
 * Logged-out users, a user record that is still loading, and a failed request all yield null.
 */
export function usePauseSubscriptionEnrollment(): PauseSubscriptionEnrollment | null {
    const {me} = useUDData();
    const userId = me.is_authenticated ? me.id : undefined;
    const enabled = !me.isLoading && Boolean(userId);

    const {data} = useGetPauseSubscriptionBannerQuery({}, {enabled});

    if (!enabled) {
        return null;
    }
    return data?.currentSubscriptionEnrollment ?? null;
}
